import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule, LOCALE_ID } from "@angular/core";
import { HttpModule } from "@angular/http";
import {
    IonicApp,
    IonicErrorHandler,
    IonicModule,
    Keyboard,
} from "ionic-angular";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicStorageModule } from "@ionic/storage";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
// Components
import { MyApp } from "./app.component";
import { CommonComponentsModule } from "../components/common-components.module";
import { MapComponentsModule } from "../components/mapa/map-components.module";
// Providers
import { EzoomApiProvider } from "../providers/ezoom-api";
import { GlobalProvider } from "../providers/global";
import { UserProvider } from "../providers/user";
import { NotificationsProvider } from "../providers/notifications";
import { MenuProvider } from "../providers/menu";

import { InAppBrowser } from "@ionic-native/in-app-browser";
import { File } from "@ionic-native/file";
import { FileTransfer } from "@ionic-native/file-transfer";
import { FileOpener } from "@ionic-native/file-opener";

import { registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";
import { NavigationProvider } from "../providers/navigation";

import { Diagnostic } from "@ionic-native/diagnostic";
import { Geolocation } from "@ionic-native/geolocation";
import { LocationAccuracy } from "@ionic-native/location-accuracy";
import { TermoAutorizacaoProvider } from "../providers/termo-autorizacao";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { MeusTreinosProvider } from "../providers/meus-treinos";
import { DatePipe } from "@angular/common";
import { CartasProvider } from "../providers/cartas";

import { Clipboard } from "@ionic-native/clipboard";
import { ClipboardClipboardProvider } from "../providers/clipboard-clipboard/clipboard-clipboard";
import { ScreenScreenProvider } from "../providers/screen-screen/screen-screen";
import { InappProvider } from "../providers/inapp/inapp";
import { CacheProvider } from "../providers/cache/cache";
import { UserClassProvider } from "../providers/user-class/user-class";
import { TrainingClassProvider } from "../providers/training-class/training-class";
import { NavProvider } from "../providers/nav/nav";
import { MonthsProvider } from "../providers/months/months";
import { NewEzoomApiProvider } from "../providers/new-ezoom-api/new-ezoom-api";
import { HttpClient, HttpClientModule, HttpParams } from "@angular/common/http";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { AppVersion } from "@ionic-native/app-version";
import { entreJogoProvider } from "../providers/entreJogo";

registerLocaleData(localePt);

@NgModule({
    declarations: [MyApp],
    imports: [
        HttpClientModule,
        BrowserModule,
        HttpModule,
        FormsModule,
        CommonComponentsModule,
        MapComponentsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        IonicModule.forRoot(MyApp, {
            menuType: "overlay",
            pageTransition: "ios-transition",
            platforms: {
                android: {
                    backButtonText: "",
                },
                ios: {
                    backButtonText: "",
                    statusbarPadding: true,
                    tabsHideOnSubPages: true,
                },
                core: {
                    pageTransition: "md-transition",
                },
            },
        }),
        IonicStorageModule.forRoot({
            name: "__rjaApp",
            driverOrder: ["localstorage", "sqlite", "indexeddb", "websql"],
        }),
    ],
    bootstrap: [IonicApp],
    entryComponents: [MyApp],
    providers: [
        StatusBar,
        SplashScreen,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        { provide: LOCALE_ID, useValue: "pt-BR" },
        GlobalProvider,
        EzoomApiProvider,
        UserProvider,
        NotificationsProvider,
        MenuProvider,
        File,
        FileTransfer,
        FileOpener,
        Keyboard,
        InAppBrowser,
        Diagnostic,
        LocationAccuracy,
        Geolocation,
        NavigationProvider,
        TermoAutorizacaoProvider,
        Camera,
        MeusTreinosProvider,
        DatePipe,
        CartasProvider,
        Clipboard,
        ClipboardClipboardProvider,
        ScreenScreenProvider,
        InappProvider,
        CacheProvider,
        UserClassProvider,
        TrainingClassProvider,
        NavProvider,
        MonthsProvider,
        NewEzoomApiProvider,
        entreJogoProvider,
        AppVersion,
    ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts